import { IDefineCommand, IQuery } from 'core-ts-types';
import { IAPPlannerResourceTab } from './../builders/planner_resource_tab_builder';
import { PlannerResourceTabs } from './../constants/planner_resource_tabs';
import { APSelectedPlannerResourceTab } from './../models/selected_planner_resource_tab_model';

export type SetSelectedPlannerResourceTabCommand = (
  selectedTabKey: IAPPlannerResourceTab['key']
) => ng.IPromise<IQuery[]>;

angular
  .module('capability-ng-academic-planner')
  .factory(
    'setSelectedPlannerResourceTabCommand',
    (defineCommandORM: IDefineCommand, ngAPSelectedPlannerResourceTab: APSelectedPlannerResourceTab) =>
      defineCommandORM(
        'setSelectedPlannerResourceTabCommand',
        (deferred, selectedTabKey: IAPPlannerResourceTab['key']) => {
          const selectedTab = PlannerResourceTabs.find((tab) => tab.key === selectedTabKey);
          if (!selectedTab) {
            deferred.reject();
            return;
          }
          ngAPSelectedPlannerResourceTab.clear().write(selectedTab);
          deferred.resolve();
        }
      )
  );



// WEBPACK FOOTER //
// ./app/vendor/capability-ng-academic-planner/src/plan/components/planner_resources/commands/set_selected_planner_resource_tab_command.ts